// extracted by mini-css-extract-plugin
module.exports = {"items_wrapper":"items_wrapper--w5QTY","item":"item--1I7YE","remove_item":"remove_item--1QlZG","add_item":"add_item--2S69h","input_new_item":"input_new_item--3lxcW"};